<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content config-modal">

    <div class="modal-header border-0 config-header">
      <div class="header-text">
        <h5 class="modal-title">Configurações</h5>
        <small class="subtitle">
          Configure preferências de notificação, segurança e aparência
        </small>
      </div>

      <button class="btn" aria-label="Fechar" (click)="close()">
        <i-lucide name="x"></i-lucide>
      </button>
    </div>

    <div class="modal-body config-body">
      <div class="toggle-item">
        <div class="toggle-text">
          <h6 class="toggle-title">Notificações por E-mail</h6>
          <p class="toggle-desc">Receber avisos importantes por e-mail</p>
        </div>
        <div class="toggle-control form-check form-switch">
          <input class="form-check-input" type="checkbox" id="emailNotif">
        </div>
      </div>

      <div class="toggle-item">
        <div class="toggle-text">
          <h6 class="toggle-title">Notificações Push</h6>
          <p class="toggle-desc">Receber notificações no navegador</p>
        </div>
        <div class="toggle-control form-check form-switch">
          <input class="form-check-input" type="checkbox" id="pushNotif">
        </div>
      </div>
    </div>

    <div class="modal-footer border-0 config-footer">
      <button type="button" class="btn btn-sm btn-cancelar" data-bs-dismiss="modal">Cancelar</button>
      <button type="button" class="btn btn-sm btn-salvar">Salvar Configurações</button>
    </div>

  </div>
</div>